module.exports = __webpack_public_path__ + "img/brightness-high-fill.85ce8c27.svg";